import { Component, OnInit } from '@angular/core';
import { faVirus } from '@fortawesome/pro-solid-svg-icons';

import { SecurityService } from 'app/core/security/security.service';
import { UserJsVm } from 'app/shared/generated/Administration/Models/User/JavaScript/UserJsVm';

@Component({
    selector: 'pcg-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

	user: UserJsVm;
	isAdmin = false;
	eventName: string;

	// Font awesome
	faIconName = { faVirus };

	constructor(private sec: SecurityService) {}

	ngOnInit() { 
		this.user = this.sec.getUser();
		this.eventName = this.user?.currentEventName;
		this.isAdmin = this.sec.hasAccess(security => security.adminFeatures); 
	}
}